import { getClientProfilePrincipalsInput } from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModalForm/fields/entities.fields.utils';
import { BASIC_ASSETS_SUBFORM } from '@/modules/entities/BasicAssetsSubform/BasicAssetsSubform.types';
import { BUSINESS_ENTITY_DETAILS_SUBFORM_NAMESPACE } from '@/modules/entities/BusinessEntityDetailsSubform/BusinessEntityDetailsSubform.types';
import {
  CREATE_ENTITY_SHORT_FORM_NAMESPACE,
  EntityShortFormShape,
} from '@/modules/entities/EntityShortFormModal/CreateEntityShortForm/CreateEntityShortForm.types';
import { getTaxStatusValuesFromEntityType } from '@/modules/entities/TaxStatusSubform/TaxStatusSubform.utils';
import { AddNewHoldingsGroupFormShape } from '@/modules/estate/EstateDirectHoldings/DirectHoldingsGroupContainer/AddNewHoldingsGroupFormModal/AddNewHoldingsGroupFormModal.types';

export function adaptFormValuesToEntityShortFormShape(
  formInput: AddNewHoldingsGroupFormShape,
  principalIds: string[],
  principalId?: string
): EntityShortFormShape {
  const { name: entityName, type: entityType } = formInput;
  if (!entityType) {
    throw new Error('Entity type is required');
  }
  if (!entityName) {
    throw new Error('Entity name is required');
  }

  const { estateInclusionStatus } =
    getTaxStatusValuesFromEntityType(entityType);

  const { principals, selectedSinglePrincipal, owners } =
    getClientProfilePrincipalsInput(entityType, principalIds, principalId!);

  return {
    [CREATE_ENTITY_SHORT_FORM_NAMESPACE]: {
      name: entityName,
      entityType,
      principals,
      selectedSinglePrincipal,
      _ownershipSum: null,
      estateInclusionStatus,
      stateInEstateStatus: null,
      defaultDocumentId: undefined,
    },
    [BUSINESS_ENTITY_DETAILS_SUBFORM_NAMESPACE]: {
      keyPeople: [],
      keyPeopleNotes: '',
      owners,
      ownershipAsOfDate: null,
      _ownershipSum: null,
      _ownershipSyncIntegrationKind: null,
      // it's okay to default this to true; it's a no-op for unintegrated entities or entities that aren't connected to supported integrations
      syncOwnership: true,
    },
    [BASIC_ASSETS_SUBFORM]: {},
  };
}
